import ReactGA from 'react-ga4';
import { matchRouteTitle, routeTitles } from './Helper';

/**
 * Track page views in Google Analytics
 * @param {string} pagePath - The path of the page
 */
export function trackPageView(pagePath) {
  const pageTitle = matchRouteTitle(pagePath, routeTitles);
  ReactGA.send({ hitType: 'pageview', page: pagePath, title: pageTitle });
  console.log('[GA] Pageview:', pagePath, pageTitle );
}

/**
 * Track time spet on a page
 * @param {string} pagePath - The path of the page
 * @param {string} pageLocation - The full URL of the page
 * @param {number} startTime - The time when the page was loaded
 */
export function trackTimeSpent(pagePath,pageLocation, startTime) {
  const duration = Math.round(Date.now() - startTime);
  const title = matchRouteTitle(pagePath, routeTitles);

  if (duration > 0) {
    ReactGA.event('time_spent_on_page', {
      engagement_time_msec: duration,
      page_title: title,
      page_path: pagePath,
      page_location: pageLocation,
    });
    console.log(`[GA] Time on page ${pagePath}: ${duration}`);
  }
}

/**
 * Track when a drawing tool is used
 * @param {string} toolName - The name of the tool (e.g., 'marker', 'eraser')
 */
export function trackToolUsage(toolName) {
  if(toolName && toolName.length > 0) {
    ReactGA.event('tool_used', {
      tool_name: toolName,
      page_title: 'Draw Board',
      page_path: '/drawboard',
    });
  }
  console.log(`[GA] Tool Used: ${toolName}`);
}

/**
 * Track when a user joins using a valid code
 * @param {string} teacherCode - The validated teacher code
 */
export function trackJoinViaTeacherCode(teacherCode) {
  if (teacherCode) {
    const codeStr = String(teacherCode);
    ReactGA.event('joined_via_code', {
      educator_code: `Code - ${codeStr}`,
      page_title: 'Draw Board',
      page_path: '/drawboard',
    });
    console.log(`[GA] Joined via teacher code: ${codeStr}`);
  }
}

/**
 *  Track when user download a word cloud 
 */
export function trackWordDownload() {
  ReactGA.event('file_download', {
    category: 'Word Download',
    type: 'Word Image',
    page_title: 'Teacher Dashboard',
    page_path: '/teacher/dashboard',
  });
  console.log(`[GA] Word download`);
}

/**
 *  Track when user download a mask image 
 * 
 * @param {string} pageTitle - The title of the page where the mask is downloaded 
 * @param {string} pagePath - The path of the page where the mask is downloaded
 */
export function trackMaskDownload(pageTitle, pagePath) {
  ReactGA.event('file_download', {
    category: 'Mask Download',
    type: 'Mask Image',
    page_title: pageTitle,
    page_path: pagePath,
  });
  console.log(`[GA] Mask download - Title: ${pageTitle}, Path: ${pagePath}`);
}

/**
 *  Track when user download a mask image 
 * 
 * @param {string} category - The category of the resource being downloaded
 * @param {string} pageTitle - The title of the page where the mask is downloaded 
 * @param {string} pagePath - The path of the page where the mask is downloaded
 */
export function trackResourceDownload(type, pageTitle, pagePath) {
    ReactGA.event('file_download', {
    category: 'Resource Download',
    type,
    page_title: pageTitle,
    page_path: pagePath,
  });
  console.log(`[GA] Resource download - Type: ${type} Title: ${pageTitle}, Path: ${pagePath}`);
}

/**
 * Track when a user abandoned during mask creation
 * @param {string} lastAction - The last action taken by the user
 */

export function trackMaskCreationAbandonment(lastAction) {
  if (lastAction) {
    ReactGA.event('mask_creation_abandoned', {
      action: lastAction,
    });
    console.log(`[GA] Mask creation abandoned: ${lastAction}`);
  } else {
    console.warn('[GA] No last action provided for mask creation abandonment tracking');
  }     
}

/** 
 * Track when a mask is submitted
 * @param {string} location - The location from which the mask was submitted
 */

export function trackMaskSubmission(location) {
    ReactGA.event('mask_submitted', {
        page_title: "Draw Board",    
        page_path: "/drawboard",
        mask_location: location,
    });
    console.log(`[GA] Mask submitted from: ${location}`);
}

/**
 * Track form confusion
 * @param {string} formName - Name of the form (e.g., 'RegistrationForm')
 * @param {string} fieldName - Field name involved 
 * @param {number} duration - Time spent on the field in seconds (optional)
 */
export function trackFormConfusion(
  formName,
  fieldName = '',
  duration = 0
) {
  const safeDuration = typeof duration === 'number' && !isNaN(duration) ? Math.round(duration) : 0;
  
  if (formName?.length > 0 && fieldName?.length > 0) {
    ReactGA.event('form_confusion', {
      form_name: formName,
      field_name: fieldName,
      duration: safeDuration,
    });

    console.log('[GA] Form Confusion:', {
      form_name: formName,
      field_name: fieldName,
      duration: safeDuration,
    });
  }
}
 